/* eslint-disable import/prefer-default-export */
import { InsightContentSettingType } from 'components/insightContent/types'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { SearchFilterComposingStrategy } from 'utils/insightModal/strategy/searchFilterComposing/searchFilterComposingStrategy'
import { composeDetailSearchFilter } from 'utils/insightModal/composeDetailSearchFilter'
import { composeDrillDownWidgetSetting } from 'utils/insightModal/composeDrillDownWidgetSetting'
import { WidgetSettingComposingStrategy } from 'utils/insightModal/strategy/widgetSettingComposing/widgetSettingComposingStrategy'
import { getRange } from 'utils/insightModal/strategy/utils/dayHours'
import AnalysisFilter from 'types/analysisFilter'

import { toFilter } from '../../../../../utils/widgetUtil'
import { DayAndHourWidgetsType } from '../../types'
import { getWeekDayAbbreviation, getHourLabel } from '../utils'

export const getRangeLabel = (insights?: Array<InsightData>) => {
  if (!insights) return ''
  const { minHour, maxHour, days } = getRange(insights)
  const startDay = getWeekDayAbbreviation(days[0])
  const startHour = getHourLabel(minHour)
  const endHour = getHourLabel(minHour === maxHour ? minHour + 1 : maxHour + 1)

  const hourRangeDisplay = startHour !== endHour ? `${startHour}-${endHour}` : ''

  if (!startDay) {
    if (minHour === maxHour) return startHour
    return `${hourRangeDisplay}`
  }

  if (days.length > 1) {
    const endDay = getWeekDayAbbreviation(days[days.length - 1])
    return `${startDay}-${endDay} ${hourRangeDisplay}`
  }

  return `${startDay} ${hourRangeDisplay}`
}

export const convertToInsightContentSetting = (
  widgetSetting: DayAndHourWidgetsType,
  strategy: SearchFilterComposingStrategy,
  selection?: Array<InsightData>
) => {
  const { viewOption } = widgetSetting

  const insightContentSetting = {
    viewOption: viewOption!,
    emptyInsight: false,
    filter: toFilter(widgetSetting),
    drillDownTypes: ['DayHour'],
    drillDownFilter: {} as AnalysisFilter,
    topicInfos: widgetSetting.topicInfos!,
    selectedTopicInfo: widgetSetting.selectedTopic,
    topicId: widgetSetting.selectedTopic.topicId!,
    insights: selection || null,
    timeZone: widgetSetting.timeZoneOption
  } as InsightContentSettingType

  if (widgetSetting.precision) {
    insightContentSetting.precision = widgetSetting.precision
  }

  const insights = selection || null

  if (insights && insights.length > 0) {
    insightContentSetting.selectionName = getRangeLabel(insights)
    // TODO: check might not need this logic
    if (insights.length > 1) {
      if (insights.length === 2) {
        insightContentSetting.selectionSecondName = getRangeLabel(insights)
      }
    }

    insightContentSetting.selectionFilter = composeDetailSearchFilter(
      strategy,
      widgetSetting,
      insights
    )
  }
  return insightContentSetting
}

export const addSelectionFilterToWidgetSetting = (
  widgetSetting: DayAndHourWidgetsType,
  strategy: WidgetSettingComposingStrategy<DayAndHourWidgetsType>,
  selection?: Array<InsightData>
) => {
  if (!widgetSetting || typeof widgetSetting !== 'object') {
    return {}
  }

  if (!selection || selection.length === 0) {
    return {}
  }
  const drillDownWidgetSetting = composeDrillDownWidgetSetting(strategy, widgetSetting, selection)
  return drillDownWidgetSetting
}
